import NullState from '../enums/NullState';
import NullStateAction from '../enums/NullStateAction';
import NullStateLocation from '../enums/NullStateLocation';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logNullStateCTAClickedParams = {
  null_action: NullStateAction;
  null_location: NullStateLocation;
  null_state: NullState;
  trail_id?: number;
};

/**
 * User clicks the CTA on a null state.
 * @param params - Attributes to log with the amplitude event
 * @param params.null_action - The null state CTA clicked by the user
 * @param params.null_location - The location in the app where the user received the null state
 * @param params.null_state - The null state shown to the user
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logNullStateCTAClicked = ({ null_action, null_location, null_state, trail_id }: logNullStateCTAClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'null state cta clicked',
    { 'null action': null_action, 'null location': null_location, 'null state': null_state, 'trail id': trail_id },
    callback
  );
};

export default logNullStateCTAClicked;
